import React, { createContext, useContext, ReactNode } from 'react';
import { useCalendarFiltersSync } from '@calendar/hooks/use-calendar-filters';
import type { FilterState } from '@calendar/components/calendar-filters';

interface CalendarFiltersContextValue {
  filters: FilterState;
  setFilters: React.Dispatch<React.SetStateAction<FilterState>>;
}

const CalendarFiltersContext = createContext<CalendarFiltersContextValue | undefined>(undefined);

export function CalendarFiltersProvider({ children }: { children: ReactNode }) {
  const [ filters, setFilters ] = useCalendarFiltersSync();
  return (
    <CalendarFiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </CalendarFiltersContext.Provider>
  );
}

export function useCalendarFiltersContext(): CalendarFiltersContextValue {
  const context = useContext(CalendarFiltersContext);
  if (!context) {
    throw new Error('useCalendarFiltersContext must be used within CalendarFiltersProvider');
  }
  return context;
} 
